module.exports = __webpack_public_path__ + "static/img/industry.435d140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/industry.png
// module id = 42QV
// module chunks = 1